import { useState } from 'react'
import CubeLayout from './CubeLayout'
import CubePopover from './CubePopover'
import { CUBES_MODULE_LAYOUT, CUBES_MODULE_INFO } from '../data/cubes'

export const ModulesUI = () => {
  const [selectedInfoKey, setSelectedInfoKey] = useState(null)
  const [cubePosition, setCubePosition] = useState(null)
  const [anchorName, setAnchorName] = useState(null)
  const [activeCubeId, setActiveCubeId] = useState(null)

  const handleCubeClick = (clickData) => {
    if (clickData && clickData.infoKey) {
      setSelectedInfoKey(clickData.infoKey)
      setCubePosition(clickData.cubePosition)
      setAnchorName(clickData.anchorName)
      setActiveCubeId(clickData.cubeId)
    } else {
      // Backward compatibility for direct infoKey
      setSelectedInfoKey(clickData)
      setCubePosition(null)
      setActiveCubeId(null)
    }
  }

  const handlePopoverClose = () => {
    setSelectedInfoKey(null)
    setCubePosition(null)
    setActiveCubeId(null)
  }

  return (
    <>
      <div className='module-wrapper pt-[4rem] md:pt-[6rem] md:mb-[7rem]'>
        <CubePopover
          infoKey={selectedInfoKey}
          cubePosition={cubePosition}
          anchorName={anchorName}
          onClose={handlePopoverClose}
        />
        <CubeLayout
          layoutData={CUBES_MODULE_LAYOUT}
          infoMap={CUBES_MODULE_INFO}
          onCubeClick={handleCubeClick}
          activeCubeId={activeCubeId}
        />
      </div>
    </>
  )
}
